import React, { useState, useEffect } from "react";
import {
  Flex,
  Button,
  Box,
  Modal,
  Text,
  List,
  Dropdown,
  Input
} from "samba-ui";

import PropTypes from "prop-types";

const UpdateTopChannelModal = ({
  isOpen,
  onClose,
  selectedTopChannel,
  onUpdate,
  onAdd,
  countryOptions,
  allSSids
}) => {
  const [country, setCountry] = useState({});
  const [ssid, setSsid] = useState("");
  const [networkCallSign, setNetworkCallSign] = useState("");
  const [sambaCallSign, setSambaCallSign] = useState("");
  const [ssidError, setSsidError] = useState("");

  useEffect(() => {
    if (selectedTopChannel && isOpen) {
      setCountry({
        label: selectedTopChannel.country,
        value: selectedTopChannel.country
      });
      setSsid(selectedTopChannel.ssid);
      setNetworkCallSign(selectedTopChannel.networkCallSign);
      setSambaCallSign(selectedTopChannel.sambaCallSign);
    }
  }, [isOpen, selectedTopChannel]);

  const cleanState = () => {
    setCountry({});
    setSsid("");
    setNetworkCallSign("");
    setSambaCallSign("");
    setSsidError("");
  };

  const onCountryChange = selected => {
    setCountry(selected);
  };

  const onSubmit = () => {
    if (selectedTopChannel) {
      onUpdate({
        country: country.value,
        ssid: parseInt(ssid),
        networkCallSign,
        sambaCallSign
      });
    } else {
      onAdd({
        country: country.value,
        ssid: parseInt(ssid),
        networkCallSign,
        sambaCallSign
      });
    }
    onClose();
  };

  const onSSidChange = e => {
    const { value } = e.target;
    setSsid(value);

    const reg = new RegExp("^[0-9]*$");

    let error = !reg.test(value) ? "SSID must be an integer" : "";
    if (allSSids.map(a => `${a}`).indexOf(value) > -1) {
      error = "SSID must be unique";
    }
    setSsidError(error);
  };

  const onNetworkCallsignChange = e => {
    const { value } = e.target;
    setNetworkCallSign(value);
  };

  const onSambaCallsignChange = e => {
    const { value } = e.target;
    setSambaCallSign(value);
  };

  const disabled =
    ssidError ||
    !(country && country.value) ||
    !ssid ||
    !networkCallSign ||
    !sambaCallSign;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        cleanState();
        onClose();
      }}
      width={800}
    >
      <Modal.Header borderColor="#d6d6d6 !important">
        <Text fontSize={2} fontWeight={500}>
          {selectedTopChannel && selectedTopChannel.id
            ? "Update the Query"
            : "Add a New Query"}
        </Text>
      </Modal.Header>
      <Modal.Content>
        <Box p={3}>
          <List.Header borderColor="#d6d6d6 !important">
            <Flex
              justifyContent="space-between"
              alignItems="center"
              textAlign="center"
            >
              <Box width={1 / 4}>Country</Box>
              <Box width={1 / 4}>SSID</Box>
              <Box width={1 / 4}>Network Call Sign</Box>
              <Box width={1 / 4}>SambaTV Call Sign</Box>
            </Flex>
          </List.Header>
          <List.Item borderColor="#d6d6d6 !important">
            <Flex alignItems="center" justifyContent="space-between">
              <Box width={150}>
                <Dropdown
                  options={countryOptions.filter(c => c.value !== "ALL")}
                  selected={country}
                  onSelect={onCountryChange}
                />
              </Box>
              <Box width={150}>
                <Input
                  style={{ width: "150px" }}
                  value={ssid}
                  onChange={onSSidChange}
                />
              </Box>
              <Box width={150}>
                <Input
                  style={{ width: "150px" }}
                  value={networkCallSign}
                  onChange={onNetworkCallsignChange}
                />
              </Box>
              <Box width={150}>
                <Input
                  style={{ width: "150px" }}
                  value={sambaCallSign}
                  onChange={onSambaCallsignChange}
                />
              </Box>
            </Flex>
          </List.Item>
          {ssidError && (
            <Text color="alert" fontSize={2}>
              {ssidError}
            </Text>
          )}
        </Box>
      </Modal.Content>

      <Modal.Actions justifyContent="flex-end" borderColor="#d6d6d6 !important">
        <Flex>
          <Box mr={3}>
            <Button
              variant="secondary"
              onClick={() => {
                cleanState();
                onClose();
              }}
            >
              Cancel
            </Button>
          </Box>
          <Button variant="primary" onClick={onSubmit} disabled={disabled}>
            {selectedTopChannel && selectedTopChannel.id ? "Update" : "Add New"}
          </Button>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};

UpdateTopChannelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
};

export default UpdateTopChannelModal;
